<div class="jadhu-loader">
  <div class="jadhu-loader-content">
    <img
      src="images/logo.png"
      alt="Jadhu"
      class="jadhu-loader-logo mb-4"
    />

    <div class="jadhu-loader-spinner"></div>

    <p>Loading...</p>
  </div>
</div>
